import { render } from "./MyVacationList.vue?vue&type=template&id=5e85a1ec"
import script from "./MyVacationList.vue?vue&type=script&lang=js"
export * from "./MyVacationList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__